export const BASE_URL =
  process.env.REACT_APP_NODE_ENV === 'development' ? process.env.REACT_APP_PROXY_URL : process.env.REACT_APP_HOST;
// Longer timeout in local dev to survive slow proxy hops / debugger pauses.
export const TIME_OUT = process.env.REACT_APP_NODE_ENV === 'development' ? 120000 : 30000;
